import { sortBy } from 'lodash-es';

export const closest = (array: number[], num: number): number => array.reduce((a, b) => (Math.abs(a - num) < Math.abs(b - num) ? a : b));

/**
 * Overrides and sets the first element as active for the given inputs.
 *
 * @param items Items with active property.
 */
export function overrideActiveItemByOrder<T extends { active?: boolean }>(items: T[]): T[] {
    if (items.length === 0) {
        return items;
    }
    return items.map((item, index) => ({
        ...item,
        active: index === 0,
    }));
}

/**
 * Utility function for sorting items by a specified key and provided order list.
 *
 * @param order - Order list.
 * @param items - Array of items to sort.
 * @param key - The property value by we want sorting.
 */
export function sortByKey<T, K extends keyof T>(order: T[K][], items: T[], key: K): T[] {
    const idOrderMap = new Map(order.map((id, index) => [id, index]));

    return sortBy(items, (item) => idOrderMap.get(item[key]) ?? Infinity);
}
